/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Localcms_Resources_Open_ArticleInputs */

const en_localcms_resources_open_article = /** @type {(inputs: Localcms_Resources_Open_ArticleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open article: ${i?.title}`)
};

/**
* | output |
* | --- |
* | "Open article: {title}" |
*
* @param {Localcms_Resources_Open_ArticleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const localcms_resources_open_article = /** @type {((inputs: Localcms_Resources_Open_ArticleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Localcms_Resources_Open_ArticleInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_localcms_resources_open_article(inputs)
});